<template>
  <div class="p-4">ClientConfiguracionPermisos</div>
</template>

<script>
export default {
  name: 'ClientConfiguracionPermisos'
}
</script>
